<style src="./ColumnResult.scss" lang="scss"></style>
<template>
  <li class="result box">
    <div v-if="status" class="spinner">
      <icon-wait class="icon" />
    </div>

    <template>
      <div v-if="!haveResult" class="editmode">
        <span class="noresult">NÃO INFORMADO</span>
      </div>
      <div v-if="haveResult" class="informations">
        <div class="description">
          <span class="title title__dist">DISTRIBUIDOR</span>
          <span class="value">{{ distributor }}</span>
          <span class="title title__lab">LABORATÓRIO</span>
          <span class="value">{{ lab }}</span>
        </div>
        <div class="values">
          <span class="title">VALOR OFERTADO</span>
          <div class="cost">
            <small class="currency">R$</small>
            <span>{{ offer | CurrencyBR("", 4) }}</span>
          </div>
          <span class="total">
            <span class="amount">
              <small class="currency">R$</small>
              {{ calculatedTotal | CurrencyBR }}
            </span>

            <span
              class="perc"
              :class="{
                perc__positive: calculatedPerc >= 0,
                perc__negative: calculatedPerc < 0
              }"
            >
              <IconArrow class="iconup" v-if="calculatedPerc >= 0" />
              <IconArrow class="icondown" v-if="calculatedPerc < 0" />
              {{ percWithoutSign }}%
            </span>
          </span>
        </div>
      </div>
    </template>
  </li>
</template>

<script>
import {
  CurrencyBR,
  DecimalNumber
} from "@/components/primitives/helpers/filters";
import { IconArrow } from "@/components/primitives/icons";

export default {
  name: "ColumnResult",
  components: {
    IconArrow
  },
  props: {
    position: {
      type: String,
      default: "winner"
    },
    info: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      status: false,
      precision: 4,
      distributor: "",
      lab: "",
      offer: 0
    };
  },
  filters: {
    CurrencyBR,
    DecimalNumber
  },
  computed: {
    haveResult() {
      return !!this.offer;
    },
    calculatedTotal() {
      const offer = this.offer;
      return this.info.quoted.quantity * offer;
    },
    calculatedPerc() {
      const v2 = this.info.quoted.cost;
      const offer = this.offer;
      const r = (offer * 100) / v2 - 100;
      return r.toFixed();
    },
    percWithoutSign() {
      return this.calculatedPerc.toString().replace("-", "");
    }
  },
  watch: {
    info: {
      handler(i) {
        this.fillMonitor(i);
      },
      deep: true
    }
  },
  mounted() {
    this.fillMonitor(this.info);
  },
  methods: {
    fillMonitor(i) {
      if (
        i.ranking &&
        i.ranking[this.position] &&
        i.ranking[this.position].price
      ) {
        this.offer = i.ranking[this.position].price;
        this.lab = i.ranking[this.position].lab;
        this.distributor = i.ranking[this.position].distributor;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/item-analysis/components/column-result/ColumnResult.vue